<template>
	<div id="alerts">
		<div v-for="(alert, i) in alerts" :key="i" class="container-fluid alert"
			:class="{ info: (alert.type === 'info'), success: (alert.type === 'success'), error: (alert.type === 'error') }">
			<div class="row">
				<div class="col-10 message">
					<span>{{ alert.message }}</span>
				</div>
				<div class="col-2 close text-center">
					<button class="button-transparent" @click="removeAlert(alert)">X</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
	methods: {
		removeAlert(alert) {
			this.$store.commit('app/removeAlert', alert)
		}
	},
	computed : {
		...mapState({
			alerts: state => state.app.alerts
		})
	}
}
</script>

<style lang="scss">
#alerts {
	position: fixed;
	z-index: 20;
	top: 0;
	left: 0;
	width: 100%;
	.alert {
		.message, .close {
			padding-top: 15px;
			padding-bottom: 15px;
			font-size: 12px;
		}
	}
	.alert.info {
		color: #004085;
		background-color: #cce5ff;
		border-color: #b8daff;
	}
	.alert.success {
		color: #155724;
		background-color: #d4edda;
		border-color: #c3e6cb;
	}
	.alert.error {
		color: #721c24;
		background-color: #f8d7da;
		border-color: #f5c6cb;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Alerts.vue